import { FormControls } from '@bridebook/web/components/wedding-website/rsvp/question-form/form-controls';
import { AddEditQuestionForm } from '@bridebook/web/components/wedding-website/wedding-details/sections/rsvp/add-edit-question-form';
import { AddEditQuestionFormContent } from '@bridebook/web/components/wedding-website/wedding-details/sections/rsvp/add-edit-question-form-content';

import {
  ResponsiveModalContent,
  ResponsiveModalFooter,
  ResponsiveModalHeader,
} from '@bridebook/aura';
import { useTranslation } from 'next-i18next';
import { useRsvpModal } from '@bridebook/web/components/wedding-website/rsvp/rsvp-modal.context';

export const QuestionForm = () => {
  const { t } = useTranslation('weddingWebsite');

  const { rsvpQuestionId, setRsvpQuestionId } = useRsvpModal();
  const navigateToList = () => setRsvpQuestionId(undefined);

  return (
    <AddEditQuestionForm questionId={rsvpQuestionId} onSuccess={navigateToList}>
      <ResponsiveModalHeader onBackButtonClick={navigateToList}>
        {t('website.rsvpQuestion.pageTitle')}
      </ResponsiveModalHeader>
      <ResponsiveModalContent className="xl:px-10">
        <div className="xl:px-[100px]">
          <AddEditQuestionFormContent questionId={rsvpQuestionId} />
        </div>
      </ResponsiveModalContent>
      <ResponsiveModalFooter>
        <FormControls questionId={rsvpQuestionId} />
      </ResponsiveModalFooter>
    </AddEditQuestionForm>
  );
};
